import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { AiOutlineRobot } from 'react-icons/ai'; // React icon for AI Modules
import { FaUserCheck } from "react-icons/fa";
import '../../styles/employee/employee-sidebar.css';
import logo from '../../assets/images/Logo.png';
import dashboardIcon from '../../assets/images/DashboardIcon.png';
import vector from '../../assets/images/Vector.png';
import assignedCandidateList from '../../assets/images/AssignedCandidateList.png';

const Sidebar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleLinkClick = () => {
    // Close sidebar on mobile after clicking a link
    setIsSidebarOpen(false);
  };

  return (
    <>
      {/* Hamburger Button */}
      {!isSidebarOpen && (
        <button
          className="emp-hamburger-btn"
          onClick={() => setIsSidebarOpen(true)}
        >
          <FaBars />
        </button>
      )}

      {/* Sidebar */}
      <aside className={`emp-app-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        {/* Logo */}
        {/* <div className="emp-sidebar-header">
          <img src={logo} alt="Logo" className="emp-sidebar-logo" />
        </div> */}
        <button
          className="emp-sidebar-close-btn"
          onClick={() => setIsSidebarOpen(false)}
        >
          <FaTimes />
        </button>
        {/* Navigation */}
        <nav className="emp-sidebar-nav">
          <ul>
            <li>
              <NavLink
                to="/employee/dashboard"
                className="emp-nav-item"
                onClick={handleLinkClick}
              >
                <span className="emp-nav-icon">
                  <img src={dashboardIcon} alt="Dashboard" className="emp-nav-icon-logo" />
                </span>
                Dashboard
              </NavLink>
            </li>

            <li className="emp-sidebar-divider" />

            <li>
              <NavLink
                to="/employee/profile"
                className="emp-nav-item"
                onClick={handleLinkClick}
              >
                <span className="emp-nav-icon">
                  <img src={vector} alt="Profile" className="emp-nav-icon-logo" />
                </span>
                Profile
              </NavLink>
            </li>

            <li className="emp-sidebar-divider" />

            <li>
              <NavLink
                to="/employee/assignedCandidates"
                className="emp-nav-item"
                onClick={handleLinkClick}
              >
                <span className="emp-nav-icon">
                  <img src={assignedCandidateList} alt="Assigned Candidates" className="emp-nav-icon-logo" />
                </span>
                Assigned Candidates
              </NavLink>
            </li>

                <li className="emp-sidebar-divider" />

           <li>
            <NavLink
              to="/employee/quickbgv"
              className="emp-nav-item"
              onClick={handleLinkClick}
            >
              <span className="emp-nav-icon">
                <FaUserCheck size={18} />
              </span>
              Quick BGV
            </NavLink>
          </li>

            {/* <li className="emp-sidebar-divider" />

            <li>
              <NavLink
                to="/employee/aiModules"
                className={({ isActive }) =>
                  `emp-nav-item ${isActive ? 'active' : ''}`
                }
              >
                <span className="emp-nav-icon ai-icon">
                  <AiOutlineRobot size={22} />
                </span>
                AI Modules
              </NavLink>
            </li> */}


          </ul>
        </nav>
      </aside>

      {/* Overlay for mobile when sidebar is open */}
      {isSidebarOpen && <div className="emp-sidebar-overlay" onClick={() => setIsSidebarOpen(false)}></div>}
    </>
  );
};

export default Sidebar;
